<template>
	<div id="loyout" class="nationwide padding-sm map-uni-container">
		<!-- <div id="screen" class="screen-nationwide padding-sm map-uni-container"> -->
			
			<div class="map-main-container">
				<!-- 左边信息栏 -->
				<div class="map-main-container-left flex flex-column">
					<infoList :titleName="'车辆信息'" :type="'car'" :dataList="carDataList"></infoList>
					<infoList :titleName="'电池信息'" :type="'battery'" :dataList="batteryDataList"></infoList>		 
				</div>
				
				<!-- 中间大屏 -->
				<div class="map-main-container-center flex1">
					<!-- <carsmap></carsmap> -->
					<div class="back point pointer" @click="backpage">
						<img class="location" src="@/assets/images/site/arrow_small.png" alt="">
						返回
					</div>
					<div class="chengyongche">
						<!-- 车 -->
						<!-- <img class="img" src="~@/assets/images/comm/cheliang.png" alt=""> -->
						<img class="img" src="~@/assets/images/comm/zhongkacheliang.png" alt="" />
						<!-- 电池 -->
						<div class="battery-box">
							<div class="gobatter point pointer" @click="goBattery">
								电池监控
								<img class="location" src="@/assets/images/site/arrow_small.png" alt="">
							</div>
						</div>
					</div>
					<div class="info-bg">
						<div class="info-box">
							<div class="top">
								<img class="location" src="~@/assets/images/newstyle/image.png" alt="">
								{{singleData.city}}
							</div>
							<div class="bottom">
								<div class="left circleMove" id="circleMove">
									<div class="circleInner flex flex-direction align-center justify-center">
									<div class="DS-font text-30 green-text">{{singleData.cur_soc ? singleData.cur_soc : '-'}}</div>
									<!-- 日换电次数 -->
									<div>soc</div>
									</div>
									<!-- <dv-decoration-9 style="width:80px;height:80px;">{{singleData.cur_soc ? singleData.cur_soc : '-'}}</dv-decoration-9> -->
								</div>
								<div class="right">
									<div class="cell">车牌：{{singleData.license_plate}}</div>
									<div class="cell">状态：{{singleData.vehicle_state}}</div>
									<div class="cell">最后更新时间： {{singleData.update_time}}</div>
								</div>
							</div>
						</div>
					</div>
					<div class="info-left-bg">
						<div class="info-left-bg-box">
							<div class="top">
								30天行驶天数
							</div>
							<div class="bottom">
								{{operation_days}} <span class="unit">d</span>
							</div>
						</div>
						<div class="info-left-bg-box">
							<div class="top">
								<!-- 换电时长均值 -->
								日均行驶时长 
							</div>
							<div class="bottom">
								{{exchange_interval_time}} <span class="unit">hours</span>
							</div>
						</div>
					</div>
				</div>
				
				
				<!-- 右边数据echart -->
				<div class="map-main-container-right flex flex-column">
					<divBox class="flex1">
						<Title :title="'电池性能'"></Title> 
						<div class="flex">
							<div class="flex flex-column flex1 justify-content align-items">
								<dv-water-level-pond class="margin-top20" :config="config" style="width:130px;height:130px" />
								<div class="margin-top10">
									电池健康度
								</div>
							</div>
						</div>
					</divBox>
					<!-- 车辆行驶里程 -->
					<divBox class="flex1" style="margin-top: 20px">
						<options24hours></options24hours>
					</divBox>
					<divBox class="flex1" style="margin-top: 20px">
						<socInterval></socInterval>
					</divBox>
				</div>
			</div>
			
			<chartList></chartList>
			
		<!-- </div> -->
	</div>
</template>

<script>

import { formatter } from '@/utils/index.js'
import { indexCenter } from '@/api/indexCenter'
// import Chart from "@/components/echart/gauge.vue";
// import uniSubTitle from "@/views/vehicle/components/uniSubTitle";
import chartList from "@/views/vehicle/components/chartList";
import infoList from "@/views/vehicle/components/infoList";
import divBox from '@/views/vehicle/components/divBox'
// import echarts from '@/views/vehicle/components/charts/echarts.vue'
import socInterval from '@/views/vehicle/components/singleCarEcharts/socInterval.vue'
import options24hours from '@/views/vehicle/components/singleCarEcharts/24hoursWarn'
import Title from '@/views/vehicle/components/title.vue'
// import carsmap from './components/carsmap.vue'
import { dataInterface } from '@/api/dataInterfaceApi';
// // 电池健康状态
// import BatteryHealthStatus from "@/components/echart/siteCharts/carAddChart.vue";
let ProgressBar = require('progressbar.js')
function playLoop(bar) {
  var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var interval = void 0;
  var playing = false;
  function animateBar() {
      bar.animate(1, function() {
          setTimeout(function() {
              bar.animate(0)
          }, 500)
      })
  }
  function resume() {
      if (playing) {
          return
      }
      playing = true;
      interval = setInterval(function() {
          bar.set(0);
          animateBar()
      }, 4e3);
      animateBar()
  }
  if (start) {
      resume()
  }
  return {
      pause: function pause() {
          if (interval) {
              bar.stop();
              clearInterval(interval)
          }
          playing = false
      },
      resume: resume
  }
}
export default {
	components: {
		// carsmap,
		// uniSubTitle,
		// BatteryHealthStatus,
		chartList,
		infoList,
		divBox,
		Title,
		// Chart,
		// echarts,
		socInterval,
		options24hours
	},
	data() {
		let whiteList = ['vehicleMapYM', 'carmapYM', 'vehicleProvinceYM', 'vehicleCityYM', 'vehicleControlYM', 'vehicleBatteryBoxYM' ]
		let { name } = this.$route || {}
		return {
			type: whiteList.includes(name) ? 1 : 0,
			batteryId: '',
			carDataList: {},
			batteryDataList: {},
			singleData: {}, //单车信息位置车牌soc 状态
			infoListData: [],
			carIndicatorsList: [],
			nowDate: "", // 当前日期
			nowTime: "", // 当前时间
			nowWeek: "", // 当前星期
			provinceStationInfo: [], //全国站点
			curProvince: -1, //当前站点
			curDistrict: -1, //当前大区
			curCity: -1, //当前城市
			showCity: false, //是否显示城市
			showDistrict: false, //是否显示大区
			cityStationInfo: [], //省级站点
			districtStationInfo: [], //市级站点
			curDistrictInfo: {
				district: "110101"
			}, //当前大区信息
			showNationDialog: false, //显示全国弹框
			showFullScreen: true, //全屏按钮
			adcode: '',
			operation_days: '', //运营天数
			exchange_interval_time: '', //换电时长均值
			config: {
				data: [66],
				shape: 'round',
				colors: ['#91D5FF', '#1890FF']
			}
		};
	},
	methods: {
		backpage() {
			window.history.go(-1)
		},
		goBattery() {
			// this.$router.push({
			//     path: '/vehicleBatteryBox',
			//     query: {
			//       batteryId: this.batteryId || 'LDP31B967MG929008'
			//     }
			// })
			this.goWeb('/vehicleBatteryBox', {
				batteryId: this.batteryId || 'LDP31B967MG929008'
			})
		},
		getCarTarget(data={}){
		  let _this = this;
		  let params = {};
		  if(data){
		    //省市区
		    params = {
		      "enCode":"TiDB-shengshiqu-cheliangzhibiao",
		      "@province":data.province||data.city||data.district
		    }
		  }else {
		    params = {
		      "enCode":"TiDB-quanguo-cheliangzhibiao"//全国
		    }
		  }
		  dataInterface
		    .dataFaceApi(params)
		    .then((res) => {
		      if(!res) return;
		      res = res[0];
		      _this.carIndicatorsList = [{
		        counts:res.changePowerVehicleNum||0,
		        text:"本月换电车辆数"
		      },{
		        counts:res['changePowerNum']||0,
		        text:"单车日均换电次数"
		      },{
		        counts:res['addVehicleNum']||0,
		        text:"本月新增车辆数"
		      },{
		        counts:res['changePowerCourse']||0,
		        text:"单车日均换电里程"
		      }];
		    })
		    .catch((err) => {
		      console.log(err);
		    });
		},
		clicMapChange() {
			console.log("mapChange", this.$refs)
		},
		//全屏
		clickFullScreen() {
			const docElm = document.documentElement
			if (docElm.requestFullscreen) {
				docElm.requestFullscreen()
			} else if (docElm.msRequestFullscreen) {
				docElm.msRequestFullscreen()
			} else if (docElm.mozRequestFullScreen) {
				docElm.mozRequestFullScreen()
			} else if (docElm.webkitRequestFullScreen) {
				docElm.webkitRequestFullScreen()
			}
			this.showFullScreen = !this.showFullScreen;
		},
		//点击退出全屏
		clickExit() {
			if (document.exitFullscreen) {
				document.exitFullscreen()
			} else if (document.msExitFullscreen) {
				document.msExitFullscreen()
			} else if (document.mozCancelFullScreen) {
				document.mozCancelFullScreen()
			} else if (document.webkitCancelFullScreen) {
				document.webkitCancelFullScreen()
			}
			this.showFullScreen = !this.showFullScreen;
		},
		//清空数据
		clearData() {
			this.districtStationInfo.length = 0;
			this.cityStationInfo.length = 0;
			this.curProvince = -1;
			this.curDistrict = -1;
			this.curCity = -1;
		},
		showNationDialogFunc() {
			this.selectCountryStationInfo();
			this.showNationDialog = true;
		},
		//跳转到全国
		jumpToNationwide() {
			this.showNationDialog = false; //关闭弹框
			// this.$router.push({
			// 	path: '/vehicleMap',
			// 	query: {}
			// })

			// this.goWeb('/vehicleMap')
		},
		//点击省级 区分 直辖市和其他
		clickProvince(item, index) {
			this.clearData();
			let adcode = parseInt(item.province);
			this.adcode = adcode;
			let updateParams = {};
			if (this.curProvince == index) {
				return;
			}
			this.curProvince = index;
			if ([110000, 120000, 500000, 310000].includes(adcode)) {
				updateParams = {
					city: adcode.toString().substring(0, 2) + '0100'
				}
				this.selectCityStationInfo(updateParams)
			} else {
				updateParams = {
					province: adcode
				}
				this.selectProvinceStationInfo(updateParams);
			}
		},
		clickCity(item, index) {
			if (this.curCity != index) {
				this.curCity = index;
				this.adcode = item.city;
				this.selectCityStationInfo({
					'city': item.city
				})
			}
		},
		clickDistrict(item, index) {
			if (this.curDistrict != index) {
				this.curDistrict = index;
				this.curDistrictInfo = item;
			}
		},
		//确定按钮
		confirm() {
			if (this.curProvince == -1 && this.curCity == -1 && this.curDistrict == -1) {
				console.log("您还没有选择省份");

				return;
			}

			if (this.curProvince > -1 && this.curCity == -1 && this.curDistrict == -1) {
				console.log("选择省份");
				this.showNationDialog = false; //关闭弹框
				// this.$router.push({
				// 	path: '/vehicleProvince',
				// 	query: {
				// 		province: this.adcode
				// 	}
				// })
				this.goWeb('/vehicleProvince', {
					province: this.adcode
				})
				return;
			}

			if (this.curProvince > -1 && this.curCity > -1 && this.curDistrict == -1) {
				console.log("选择城市");
				this.showNationDialog = false; //关闭弹框
				// this.$router.push({
				// 	path: '/vehicleProvince',
				// 	query: {
				// 		city: this.adcode
				// 	}
				// })
				this.goWeb('/vehicleProvince', {
					city: this.adcode
				})
				return;
			}

			if (this.curProvince > -1 && this.curCity > -1 && this.curDistrict > -1) {
				console.log("选择城市");
				this.showNationDialog = false; //关闭弹框
				// this.$router.push({
				// 	path: '/vehicleProvince',
				// 	query: {
				// 		adcode: this.curDistrictInfo.district
				// 	}
				// })
				this.goWeb('/vehicleProvince', {
					adcode: this.curDistrictInfo.district
				})
				return;
			}
		},
		//获取全国站点数据
		selectCountryStationInfo() {
			let _this = this;
			indexCenter
				.selectCountryStationInfo()
				.then((res) => {
					if (!res) return;
					this.provinceStationInfo = res;
				})
				.catch((err) => {});
		},
		//获取省级站点数据
		selectProvinceStationInfo(updateParams) {
			let _this = this;
			//获取省的站点信息
			indexCenter
				.selectProvinceStationInfo(updateParams)
				.then((res) => {
					if (!res) return;
					this.cityStationInfo = res;
					if (res.length > 0) {
						this.showCity = true;
						this.showDistrict = false;
					} else {
						this.showCity = false;
					}
				})
				.catch((err) => {
					console.log(err);
				});
		},
		//获取区级站点数据
		selectCityStationInfo(updateParams, adcode, type) {
			let _this = this;
			//获取省的站点信息
			indexCenter
				.selectCityStationInfo(updateParams)
				.then((res) => {
					if (!res) return;
					this.districtStationInfo = res;
					if (res.length > 0) {
						this.showDistrict = true;
					} else {
						this.showDistrict = false;
					}
				})
				.catch((err) => {
					console.log(err);
				});
		},
		currentTime() {
			setInterval(this.getDate, 60);
		},
		getDate: function() {
			var _this = this;
			let yy = new Date().getFullYear();
			let mm = new Date().getMonth() + 1;
			let dd = new Date().getDate();
			let week = new Date().getDay();
			let hh = new Date().getHours();
			let mf =
				new Date().getMinutes() < 10 ?
				"0" + new Date().getMinutes() :
				new Date().getMinutes();
			if (week == 1) {
				this.nowWeek = "星期一";
			} else if (week == 2) {
				this.nowWeek = "星期二";
			} else if (week == 3) {
				this.nowWeek = "星期三";
			} else if (week == 4) {
				this.nowWeek = "星期四";
			} else if (week == 5) {
				this.nowWeek = "星期五";
			} else if (week == 6) {
				this.nowWeek = "星期六";
			} else {
				this.nowWeek = "星期日";
			}
			_this.nowTime = hh + ":" + mf;
			_this.nowDate = yy + "年" + mm + "月" + dd + "日";
		},
		
		
		
		
		
		// 获取车辆信息
		getCarInfoList() {
			let params = {
		      "enCode": "per_vehicle-VIN码-车牌号-车型-所属运营商",
		      "@VEHICLE_VIN": localStorage.getItem("newVehicleNum") ? localStorage.getItem("newVehicleNum") : 'LDP31B967MG929008'
		    }
			dataInterface.dataFaceApi(params).then((res) => {
				this.carDataList = res[0] ? res[0] : {}
			}).catch((err) => {
			    console.log(err);
			  });
		},
		//获取电池信息
		getBatteryInfoList() {
			let params = {
		      "enCode": "per_vehicle-电池编码-生厂商-额定电压-额定容量-质保年限-质保里程-充电电量-累计充电",
		      "@VEHICLE_VIN": localStorage.getItem("newVehicleNum") ? localStorage.getItem("newVehicleNum") : 'LDP31B967MG929008'
		    }
			dataInterface.dataFaceApi(params).then((res) => {
				if(!res || !res.length) return
				this.batteryDataList = res[0] || {}
				this.batteryId = res[0] && res[0].battery_id || ''
			}).catch((err) => {
			    console.log(err);
			  });
		},
		//获取电池健康度
		getBatteryHealthy() {
			let params = {
		      "enCode": "per_vehicle-电池健康度",
		      "@VEHICLE_VIN": localStorage.getItem("newVehicleNum") ? localStorage.getItem("newVehicleNum") : 'LDP31B967MG929008'
		    }
			dataInterface.dataFaceApi(params).then((res) => {
				if(res) {
					let arr = []
					this.config.data = [res[0].soh*1]
					this.config = {
						...this.config
					}
				}
				
			}).catch((err) => {
			    console.log(err);
			  });
		},
		//获取运营天数时长
		getDayAndTime() {
			let params = {
		    //   "enCode": "per_vehicle-运营天数-换电时长均值",
			  "enCode": "per_vehicle-30天运营天数-日均运营时长",
		      "@VEHICLE_VIN": localStorage.getItem("newVehicleNum") || 'LDP31B967MG929008'
		    }
			dataInterface.dataFaceApi(params).then((res) => {
				console.log(params,'params30天运营天数-日均运营时长')
				console.log(res,'res30天运营天数-日均运营时长')
				if(res) {
					this.exchange_interval_time = res[0] && res[0].daily_operating_time || '-'
					this.operation_days = res[0] && res[0].operation_days || '-'
				}
			}).catch((err) => {
			    console.log(err);
			  });
		},
		//获取单车信息
		getSingleCar() {
			let params = {
		      "enCode": "per_vehicle-当前省市-车牌-状态-当前SOC",
		      "@VEHICLE_VIN": localStorage.getItem("newVehicleNum") ? localStorage.getItem("newVehicleNum") : 'LDP31B967MG929008'
		    }
			dataInterface.dataFaceApi(params).then((res) => {
				if(res) {
					this.singleData = res[0] ? res[0] : {}
				}
				// setTimeout(() => {
				// 	this.getSingleCar()
				// }, 30000)
			}).catch((err) => {
			    console.log(err);
			  });
		},
		goWeb(path, query) {
			if(this.type == 1) {
				path += 'YM'
			}
			this.$router.push({
				path,
				query
			})
		}
	},
	filters: {
		formatterProvince(name) {
			if (!name) return '';
			console.log(name)
			return formatter(name)
		},
	},
	mounted() {
		this.currentTime()
		this.getCarTarget()
		this.getCarInfoList()
		this.getBatteryInfoList()
		this.getBatteryHealthy()
		this.getDayAndTime()
		this.getSingleCar()
		
		var progressChild = new ProgressBar.Circle('#circleMove', {
		    strokeWidth: 4,
		    color: '#00BAB8',
		    easing: 'easeInOut',
		    duration: 1400,
		    trailColor: '#00BAB8',
		    trailWidth: 1,
		    svgStyle: null
		
		});
		var loop = playLoop(progressChild, false)
		loop.resume();
	},
	// 销毁定时器
	beforeDestroy: function() {
		if (this.getDate) {
			clearInterval(this.getDate); // 在Vue实例销毁前，清除时间定时器
		}
	}
}
</script>

<style lang="scss" scope>
@import '@/assets/scss/pc.scss';
@import '@/assets/scss/main-map.scss';
.nationwide {
	padding-bottom: 100px;
}
.map-main-container-left, .map-main-container-right {
	width: 300px;
	flex-shrink: 0;
}
.map-main-container-right {
	height: 100%;
}
.map-uni-container {

	// 全国省市区-弹框
	.new-Dialog {
		top: 50% !important;
	}
}
</style>